import React from "react";

import Avatar from "./Avatar";
import {
  slaChip,
  shortTime,
  tagChip,
  chDot,
  previewOf,
  statusLabel,
} from "./decorate";

// Linha da lista de tickets. Visual por variante (avatar, nome, hora, unread,
// preview, chip de tag + dot de canal + chip SLA, botão Aceitar nos pending).
// tag/canal vêm de um lead opcional (lazy) — se ausentes, omitidos graciosamente.
const TicketItem = ({
  V,
  ticket,
  lead,
  active,
  showPrev,
  showStatus,
  slaLimite,
  onSelect,
  onAccept,
}) => {
  const name = ticket.contact?.name || ticket.contact?.number || "Sem nome";
  const sla = slaChip(ticket, slaLimite);
  const tag = tagChip(lead?.tag);
  const ch = chDot(lead?.channel);
  const unread = Number(ticket.unreadMessages) || 0;
  const isWaiting = ticket.status === "pending";
  const preview = previewOf(ticket);
  const soft = V.key === "c";
  const funnel = V.key === "b";

  const rowBg = active ? V.activeBg : soft ? "#FFFFFF" : "transparent";

  const rowStyle = soft
    ? {
        display: "flex",
        gap: 10,
        padding: "11px 12px",
        borderRadius: V.listRowRadius,
        cursor: "pointer",
        background: rowBg,
        boxShadow: "0 3px 10px rgba(80,60,120,.07)",
        border: `1.5px solid ${active ? V.activeEdge : "transparent"}`,
      }
    : funnel
      ? {
          display: "flex",
          gap: 9,
          padding: "9px 12px",
          borderBottom: V.rowBorder,
          cursor: "pointer",
          borderLeft: `3px solid ${active ? V.activeEdge : "transparent"}`,
          background: rowBg,
        }
      : {
          display: "flex",
          gap: 10,
          padding: "11px 12px",
          borderBottom: V.rowBorder,
          cursor: "pointer",
          background: rowBg,
        };

  const avSize = V.avatarRowSize;

  return (
    <div onClick={onSelect} style={rowStyle}>
      <Avatar
        url={ticket.contact?.profilePicUrl}
        name={name}
        size={avSize}
        radius={V.avatarRadius}
        fontSize={funnel ? 12 : 13}
      />
      <div
        style={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
          <span
            style={{
              fontSize: funnel ? 13 : 13.5,
              fontWeight: 800,
              color: V.textStrong,
              flex: 1,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {name}
          </span>
          <span
            style={{ fontSize: 10.5, fontWeight: 700, color: V.labelMuted }}
          >
            {shortTime(ticket.updatedAt)}
          </span>
          {unread > 0 && (
            <span
              style={{
                background: V.prim,
                color: "#fff",
                borderRadius: 999,
                minWidth: 16,
                height: 16,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 9.5,
                fontWeight: 800,
                padding: "0 4px",
              }}
            >
              {unread}
            </span>
          )}
        </div>
        {showPrev && preview ? (
          <div
            style={{
              fontSize: funnel ? 11.5 : 12,
              color: V.sublabel,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {preview}
          </div>
        ) : null}
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          {tag && (
            <span
              style={{
                background: tag.bg,
                color: tag.color,
                fontSize: 9.5,
                fontWeight: 800,
                padding: funnel ? "1px 7px" : "1px 8px",
                borderRadius: V.tagRadius,
              }}
            >
              {tag.label}
            </span>
          )}
          {ch && (
            <span
              title={ch.label}
              style={{
                width: 7,
                height: 7,
                borderRadius: "50%",
                background: ch.color,
                flex: "none",
              }}
            />
          )}
          {showStatus && (
            <span
              style={{
                background: soft ? "#F3F1F8" : funnel ? "#F4F6F9" : "#F4EFE4",
                color: soft ? "#5A4B6E" : funnel ? "#3D4756" : "#6B6456",
                fontSize: 9.5,
                fontWeight: 800,
                padding: funnel ? "1px 7px" : "1px 8px",
                borderRadius: V.tagRadius,
              }}
            >
              {statusLabel(ticket.status)}
            </span>
          )}
          <span style={{ flex: 1 }} />
          {isWaiting && (
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onAccept();
              }}
              style={{
                background: V.prim,
                border: "none",
                color: "#fff",
                borderRadius: funnel ? 6 : 999,
                padding: funnel ? "3px 10px" : "3px 11px",
                fontWeight: 800,
                fontSize: 10,
                fontFamily: "inherit",
                cursor: "pointer",
              }}
            >
              Aceitar
            </button>
          )}
          <span
            style={{
              background: sla.bg,
              color: sla.text,
              fontSize: 10,
              fontWeight: 800,
              padding: funnel ? "1px 7px" : "1px 8px",
              borderRadius: funnel ? 6 : 999,
            }}
          >
            {sla.label}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TicketItem;
